<template>
  <div class="footer-container">
    <div class="footer">
      <div class="footer__footer">
        <div class="beian">
          <div class="">
            <img src="@/assets/img/plicese.png" class="img-P"></img>
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002006517" rel="noreferrer" target="_blank">粤公网安备44030002006517号</a >
          </div>
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >Copyright ©2015-2025 迪瓜租机 版权所有,粤ICP备2022141223号-1</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.footer-container {
  .footer {
    color: #fff;
    background-color: #606060;
    padding: 0 100px;
    &__footer {
      .line {
        display: flex;
        align-items: center;
        color: $color-second;
        padding-top: 40px;
        &__left,
        &__right {
          flex: 1;
          border-top: 1px solid $color-second;
        }
        &__content {
          font-size: 14px;
          padding: 0 40px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .beian {
        text-align: center;
        padding: 20px 0;
        a {
          font-family:
            PingFang SC,
            PingFang SC;
          font-size: 14px;
          color: #999999;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          &:hover {
            color: #fff!important;
          }
        }
        .img-P{
          width: 18px;
          height: 18px;
          display: inline-block;
          margin: 0 5px;
        }
      }
    }
  }
}
</style>
